/*
*
* File JS per la pagina base
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroBase from '../../components/hero-base/hero-base';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './basic-page.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

addEventListener('DOMContentLoaded', (evt) =>
{
    heroBase();
});

//--------------------------------------------------------------------//